import FormulaValidatorWorker from "./FormulaValidatorWorker?worker&inline";
import type {FormulaValidatorWorkerModule} from "./FormulaValidatorWorker";
import {invoke} from "./WorkerModule";

export async function validator(expression: string)
{
    const result = await invoke<FormulaValidatorWorkerModule, "validate">(new FormulaValidatorWorker(), "validate", expression);
    return result === null ? [] : [result];
}
